import { AddToFavoriteButton } from '@/features/add-to-favorite-button/ui/AddToFavoriteButton';

export { AddToFavoriteButton };
